import React from 'react';
import withStyles from '@mui/styles/withStyles';
import { stringIsNullOrEmpty } from '../../utils/strings';
import { FlagIcon } from '../IconIndex';

export default withStyles({})(({ variant = 'urgent', showTitle = false }) => {
    let cssVariant = null;
    if (!stringIsNullOrEmpty(variant)) cssVariant = `attention-required--${variant}`;
    const flag = (ATTENTION_FLAGS.find(flag => variant === flag.variant) || { label: 'NEW', title: 'Recent' });
    return (
        <div className={`attention-required ${cssVariant || ''}`} title={flag.title}>
            <div className="attention" />
            <FlagIcon style={{ position: 'relative' }} />
            <p>{flag.label}{!!showTitle && <>={flag.title}</>}</p>
        </div>
    );
});

export const ATTENTION_FLAGS = [
    { label: 'A', title: 'Attention Required', variant: 'urgent' },
    { label: 'W', title: 'Witness Of Insertion', variant: 'woi' },
    { label: 'V', title: 'Has Viewing', variant: 'viewing' },
    { label: 'S', title: 'Same-day Cremation', variant: 'sameday' },
    { label: 'P', title: 'Priority Cremation', variant: 'nextday' }
];
